import React from 'react';
import EntrancesTabs from '../../../../../../../HousingStock/components/ui/EntrancesTabs/EntrancesTabs';

const emptyArr = [];

const GridEntranceTabs = ({
  className,
  entrancesInView,
  onChange,
  gridData,
}) => {
  return (
    <EntrancesTabs
      className={className}
      items={gridData.length > 1 ? gridData : emptyArr}
      tabsValue={entrancesInView}
      onChange={onChange}
    />
  );
};

const EntranceTabs = ({ className, entrancesInView, onChange, gridData }) => {
  const handleChange = (_evt, newValue) => {
    onChange(newValue);
  };

  return (
    <GridEntranceTabs
      className={className}
      onChange={handleChange}
      entrancesInView={entrancesInView}
      gridData={gridData}
    />
  );
};

export default EntranceTabs;
